import { connect } from 'react-redux';
import { ModalInfo } from './ModalOrphanDetails';
import { selectors } from '../../store';

const mapStateToProps = state => ({
  slotDetails: selectors.getEventSelectedData(state)
});

export default connect(mapStateToProps)(ModalInfo);
